export default "__VITE_ASSET__CZvaDg2G__"